/*                                                   */

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const getInvoke =
  (getElement: () => HTMLElement | null | undefined) =>
  (identifier: string, ...args: unknown[]): any => {
    const element = getElement();
    if (element && identifier in element && typeof element[identifier as never] === "function") {
      /*                                                                          */
      return (element[identifier as never] as (...args: unknown[]) => unknown)(...args);
    }
  };
